import { EventContextProvider } from "@codat/analytics";
import { CardIcon, useToast } from "@codat/orchard-ui";
import { useUpdateProductStatus } from "api/public";
import { useProducts } from "contexts/ProductsContext";
import { useUserState } from "portal-ui-remote/UserStateContext";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { productIds } from "utils";

import { paths } from "components/App/paths";
import LoadingPantoModal from "components/LoadingPantoModal";
import ProductModal from "components/ProductModal";

interface SyncForExpensesModalProps {
  onClose: () => void;
}

const SyncForExpensesModal = ({ onClose }: SyncForExpensesModalProps) => {
  const { userState } = useUserState();
  const { addToast } = useToast();
  const history = useHistory();
  const isAdminUser =
    !!userState && userState.userPermissions.includes("apiKeys_view");

  const { refetch: refetchProducts } = useProducts();
  const [showProductModal, setShowProductModal] = useState(true);
  const [showLoadingPanto, setShowLoadingPanto] = useState(false);
  const [, enableSyncForExpenses] = useUpdateProductStatus({
    productId: productIds.syncForExpensesV1,
    status: "Enabled",
  });

  const handleEnableSyncForExpenses = () => {
    setShowLoadingPanto(true);
    setShowProductModal(false);
    enableSyncForExpenses()
      .then(() => {
        refetchProducts();
      })
      .catch(() => {
        setShowLoadingPanto(false);
        addToast({
          message: "Failed to enable Sync For Expenses",
          variant: "error",
        });
      });
  };

  return (
    <EventContextProvider name="Sync For Expenses Modal">
      <ProductModal
        onClose={onClose}
        isOpen={showProductModal}
        productName="Sync For Expenses"
        productHeader="Embedded accounting integrations for corporate card providers and expense management platforms"
        hideAssessSyncForCommerceWarning={true}
        learnMoreUrl="https://docs.codat.io/sync-for-expenses/overview"
        productIcon={<CardIcon />}
        isAdmin={isAdminUser}
        onEnable={handleEnableSyncForExpenses}
      />
      {showLoadingPanto && (
        <LoadingPantoModal
          title="Enabling Sync For Expenses"
          items={[
            "Configuring account",
            "Updating home page",
            "Warming up integrations",
          ]}
          onComplete={() => {
            history.push(paths.products.SYNC_FOR_EXPENSES);
            onClose();
          }}
        />
      )}
    </EventContextProvider>
  );
};

export default SyncForExpensesModal;
